var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('list',{attrs:{"fs":_vm.brandFields,"api":"brands","editLink":"/admin/brands","addLink":"/admin/brands/new"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }